<template>

    <dialog-fullscreen :visibility.sync='visibility' :indicator='indicator'>
        <template v-slot:title>Обновление фразы</template>
        <template v-slot:action>
            <v-btn
                    text
                    color='green darken-2'
                    @click="updateWordstatplace"
            >
                Обновить
            </v-btn>
        </template>
        <template v-slot:content>

            <v-form v-model='validStatplace' style='min-width: 320px; max-width: 420px;'>

                <template>
                    <v-text-field disabled label='Аккаунт Яндекса' v-model="wordstatplace.user_login"></v-text-field>
                </template>
                <label>Фраза(ы) (Не больше 10 фраз)</label>
                <vue-tags-input
                        v-model="phrase"
                        :tags="wordstatplace.phrases"
                        :max-tags="10"
                        @tags-changed="newPhrases => wordstatplace.phrases = newPhrases"
                />
                <br>
                <label>Регионы</label>
                <treeselect
                        v-model="wordstatplace.geo_id"
                        :multiple="true"
                        :options="regions"
                        :normalizer="normalize"
                        return-object
                />

            </v-form>

        </template>

    </dialog-fullscreen>

</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import VueTagsInput from '@johmun/vue-tags-input';
    import DialogFullscreen from '@/components/elements/dialogs/Fullscreen.vue'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'

    export default {

        name: 'WordstatplaceUpdateMenu',
        props: ['postAction', 'wordstatplace', 'initialState'],
        components: {'dialog-fullscreen': DialogFullscreen, VueTagsInput, Treeselect},
        data() {
            return {
                validStatplace: false,
                visibility: false,
                visibilitySecondary: this.initialState,
                indicator: false,
                indicatorSecondary: false,
                phrase: '',
                regions: [],
                flat_regions: [],

            }
        },
        methods: {
            normalize(node) {
                return {
                    id: node.region_id,
                    label: node.region_name,
                    children: node.children
                }
            },
            getRegions() {
                this.$http.get(this.$store.getters.endpoint + '/db/list', {
                    emulateJSON: true,
                    params: {'login': this.$store.getters.userLogin, 'kind': 'regions'},
                    headers: this.$store.state.restrictedHeaders
                }).then(
                    r => {
                        let response = r.body;
                        if (response.result) {
                            this.regions = response.data.grouped_data;
                            this.flat_regions = response.data.flat_data;
                        } else {
                            console.log(response)
                        }
                    }
                )
            },
            dd() {
                console.log(this.wordstatplace)
            },
            updateWordstatplace() {
                this.indicator = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                const requestData = {
                    login: this.$store.getters.userLogin
                }
                const i = {
                    phrases: this.wordstatplace.phrases.map(el => el.text),
                    geo_id: this.flat_regions.filter(el => {
                        return this.wordstatplace.geo_id.indexOf(el.region_id) !== -1
                    }),
                    id: this.wordstatplace.id
                };
                this.$http.put(this.$store.getters.endpoint + '/db/project/' + this.wordstatplace.project_id + '/wordstatplaces', {
                    ...requestData,
                    ...{ 'wordstatplace': i }
                }, {
                    headers: { ...this.$store.state.restrictedHeaders,
                        ...requestHeaders
                    }
                }).then(
                    r => {
                        let response = r.body;
                        if (response.result) {
                            this.indicator = false;
                            this.visibility = false;
                            this.postAction('wordstatplaces')
                        }else {
                            this.errorCreate = true;
                            console.log(response)
                        }

                    }, (r) => {
                        this.indicator = false;
                        let error = r.body;
                        console.log(error)
                    }
                )
            }
        },
        watch: {
            initialState(value) {
                this.visibility = value
                if (value) {
                    this.getRegions()

                }
            },
            visibility(value) {
                this.$emit('update:initialState', value);
            },
        }
    }
</script>
